import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/esnext.typed-array.find-last.js";
import "core-js/modules/esnext.typed-array.find-last-index.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4929c902"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container mg-b--15"
};
const _hoisted_3 = {
  class: "table__container",
  ref: "tableContainer"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "btn_list"
};
const _hoisted_6 = {
  key: 0,
  class: "upload_btn_container"
};
const _hoisted_7 = {
  class: "table-list",
  ref: "tableWarpRef"
};
const _hoisted_8 = {
  key: 1
};
import { ref, reactive, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus';
import Buttons from '@/components/Buttons/index.vue';
import { messageBox } from '@/utils/validate';
import { objToArr, getItemByProp } from '@/utils/tools.ts';
import dayjs from 'dayjs';
import { getCurrentTime } from '@/utils/timeFormat';
import TagType from '@/views/common/TagType/index.vue';
import { useCommon } from '@/store/useCommon';
import CustomIptvDetail from './customIptvDetail.vue';
import CreateGroup from './createGroup.vue';
import EditGroup from './editGroup.vue';
import CustomIptv from './customIptv.vue';
import AddSn from './addSN.vue';
import { areaOptions } from '@/utils/city';
import { useBrandsByUser, PrefixInteger } from '@/utils/cacheData';
import { getSnGroupListApi, getSolutionSelectDataAPi, getIptvSnListApi, deleteIptvSnListApi, getIptvModelListApi, verifyCustomInfoApi, deleteSnGroupApi, getModelsApi } from '@/api/live';
import TipsDialog from './tipsDialog.vue';
import { getPlatformList } from '@/api/common';
import { baseUrl } from '@/api/liveInstance'; // 表格列排序

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const isIptvAccount = useCommon().userData.roles.some(item => /iptv/ig.test(item)); //区分是否为iptv供应商账号

    console.log('是iptv供应商吗', isIptvAccount); //运营商id vno账号下有一个id，否则就是根据下拉框来选  注意：后续端口用到cpspId时，如果不是vno账号要重新从sessionStorage获取

    const cpspId = isIptvAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    sessionStorage.setItem('isIptvAccount', isIptvAccount); //sessionStorage,后面相关的弹框用这里设置的数据判断是否iptv账号

    const uploadHeaders = ref({
      Token: useCommon().token,
      'userId': useCommon().userData.id
    });
    const userType = isIptvAccount ? 1 : 0;
    let hostname = window.location.hostname;
    const actionUrl = /managemango/.test(hostname) ? `${baseUrl}/api/live/live/v2/api/web/iptv/sn/importSn?userType=${userType}&userId=${useCommon().userData.id}` : `${baseUrl}/live/v2/api/web/iptv/sn/importSn?userType=${userType}&userId=${useCommon().userData.id}`;
    const dialogVisible = ref(false);
    const targetUpload = ref();
    const selectedIdList = ref([]);
    const selectedList = ref([]);
    const platFormList = ref([]);
    const tableRef = ref();
    const tagRef = ref(null);
    const activeTag = ref(undefined); //激活的tag标签，默认0:全部

    const detailObj = ref({
      visible: false,
      data: null,
      mode: 'edit',
      from: 0,
      dialogWidth: '65%',
      id: undefined
    });
    const createObj = ref({
      visible: false
    });
    const editGroupObj = ref({
      visible: false,
      id: undefined
    });
    const customIptvObj = ref({
      visible: false,
      data: null,
      from: 0,
      id: undefined,
      mode: 'add'
    });
    const addSnObj = ref({
      visible: false,
      from: 1 //1:sn组 2：sn

    });
    const modelOptions = ref([{
      value: '',
      label: t('全部')
    }]);
    const pidOptions = ref([{
      label: t('全部'),
      value: ''
    }]);
    const brandOptions = ref(null);
    const REVIEW_STATUS = {
      '0': 'Model列表',
      '1': 'SN组列表',
      '2': 'SN列表'
    };
    const customOptions = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('否'),
      value: 0
    }, {
      label: t('是'),
      value: 1
    }]);
    const isShowAside = ref(true);
    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name'); //return isShowAside.value ? common : [{type: 'close', name: '', noActive: true, icon: 'icon-ic_list'}, ...common]
      // vno账号不能显示model列表，系统用户显示model列表

      activeTag.value = isIptvAccount ? 1 : 0;
      return isIptvAccount ? common.filter(item => item.type !== '0') : common;
    });

    const setLoading2S = () => {
      setTimeout(() => {
        loading.value = false;
      }, 2000);
    }; // 懒加载区域数据方法


    const loadRegionData = (node, resolve) => {
      // 初始选项 - 只加载大洲级别数据
      if (node && node.level === 0) {
        const continentData = areaOptions.map(continent => ({
          label: continent.label,
          value: continent.value,
          c_name: continent.c_name,
          isLeaf: false,
          children: []
        }));
        resolve([{
          label: t('全球'),
          value: 'global',
          isLeaf: true
        }, ...continentData]);
      } // 一级节点（大洲），懒加载国家数据


      if (node && node.level === 1) {
        const continentData = areaOptions.find(item => item.value === node.data.value);

        if (continentData && continentData.children) {
          const countryData = continentData.children.map(country => ({ ...country,
            isLeaf: true
          }));
          resolve(countryData);
        } else {
          resolve([]);
        }
      }
    }; // 处理点击事件


    const handleTagClick = tag => {
      // if(tag.type === 'close') return closeAside()
      activeTag.value = tag.type;
      loading.value = true;
      setLoading2S();
    };

    onMounted(() => {
      if (!isIptvAccount) {
        getBrands(); //系统用户才获取品牌信息
      }

      if (activeTag.value == 0) {
        getIptvModelList(1, 10, searchParams.value);
      } else {
        getSnGroupList(1, 10, searchParams.value);
      }
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        list: brandOptions,
        valueKey: 'cid',
        labelKey: 'prefixName',
        controller: () => {
          if (!isIptvAccount) return true;
        },
        change: async val => {
          if (val === '') {
            modelOptions.value = [{
              label: t('全部'),
              value: ''
            }];
            searchConfig.formData.pid = '';
            return searchConfig.formData.mid = '';
          }

          let params = {
            cid: val
          }; //{  pid:val, cid:cpspId }

          getModelList(params);
          const platforms = await getPlatformLists(params);
          let item = getItemByProp(searchConfig.formList, 'pid');
          if (item) item.list = [...platforms];
        }
      }, {
        label: '平台',
        prop: 'pid',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: [],
        labelKey: 'prefixName',
        valueKey: 'pid'
      }, {
        label: '方案组',
        prop: 'solutionId',
        widgetType: 'Select',
        list: pidOptions,
        loading: false,
        controller: () => {
          if (activeTag.value == 0) return true;
        },
        visibleChange: isVisible => {
          let item = getItemByProp(searchConfig.formList, 'solutionId');

          if (isVisible && pidOptions.value.length <= 1) {
            item.loading = true;
            getSolutionSelectData();
            item.loading = false;
          }
        }
      }, {
        label: 'Model',
        prop: 'mid',
        widgetType: 'Select',
        list: modelOptions
      }, {
        label: '关键字',
        prop: 'keyword',
        widgetType: 'input',
        list: [],
        controller: () => {
          if (activeTag.value == 1) return true;
        }
      }, {
        label: 'SN',
        prop: 'sn',
        widgetType: 'input',
        controller: () => {
          if (activeTag.value == 2) return true;
        }
      }, {
        label: '运营区域',
        prop: 'region',
        widgetType: 'treeSelect',
        filterable: true,
        lazy: true,
        loadMethod: 'loadRegionData',
        list: [{
          label: t('全球'),
          value: 'global'
        }]
      }, {
        label: '是否定制',
        prop: 'customization',
        widgetType: 'Select',
        list: customOptions,
        controller: () => {
          if (activeTag.value == 0) return true;
        }
      }],
      formData: {
        customization: '',
        region: 'global',
        mid: '',
        solutionId: '',
        cid: '',
        pid: ''
      }
    });

    const handleReset = () => {
      searchParams.value = {
        customization: ''
      };
      searchConfig.formData = {
        customization: '',
        region: '',
        mid: '',
        solutionId: '',
        cid: '',
        pid: ''
      };
      sortParams.value = {
        sortKey: undefined,
        isAsc: undefined
      };
      modelOptions.value = [{
        label: t('全部'),
        value: ''
      }];
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(1, 10);
          break;

        case 1:
          getSnGroupList(1, 10);
          break;

        case 2:
          getIptvSnList(1, 10);
          break;
      }
    };

    let searchParams = ref({});

    const handleSearch = formData => {
      for (const key in formData) {
        switch (key) {
          case 'cid':
            searchParams.value.cid = formData[key];
            break;

          case 'solutionId':
            searchParams.value.solutionId = formData[key];
            break;

          case 'mid':
            searchParams.value.mid = formData[key];
            break;

          case 'pid':
            searchParams.value.pid = formData[key].join(',');
            break;

          case 'keyword':
            searchParams.value.keyword = formData[key];
            break;

          case 'sn':
            searchParams.value.sn = formData[key];
            break;

          case 'region':
            searchParams.value.region = formData[key];
            break;

          case 'customization':
            searchParams.value.customization = formData[key];
            break;
        }
      }

      for (let key in searchParams.value) {
        if (searchParams.value[key] === '') {
          delete searchParams.value[key];
        }
      }

      console.log('searchParams', searchParams.value);

      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 1:
          getSnGroupList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 2:
          getIptvSnList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;
      }
    };

    const columnConfig = reactive({
      // 在下面watch监听器配置, activeTag默认undefined, 在Tags computed的时候改变这个值激活对应的列表
      columnList: []
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: t('创建分组'),
        type: 'green',
        controller: data => {
          if (activeTag.value == 1) return true;
        },
        func: () => {
          createObj.value.visible = true;
        }
      }, {
        label: t('批量'),
        type: 'primary',
        func: () => {
          verifyCustomInfo(selectedIdList.value, Number(activeTag.value) + 1, useCommon().userData.id, useCommon().userData.roles);
        }
      }, {
        label: '',
        key: 0,
        func: () => {},
        cellSlot: true
      }]
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
      console.log('activeTag.value', activeTag.value);

      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(1, size, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 1:
          getSnGroupList(1, size, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 2:
          getIptvSnList(1, size, { ...searchParams.value,
            ...sortParams.value
          });
          break;
      }
    };

    const currentChange = page => {
      tableConfig.paginationConfig.page = page;
      console.log('activeTag.value', activeTag.value);

      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 1:
          getSnGroupList(page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 2:
          getIptvSnList(page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;
      }
    }; // 刷新节目列表


    const onUpdateList = () => {
      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 1:
          getSnGroupList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 2:
          getIptvSnList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, { ...searchParams.value,
            ...sortParams.value
          });
          break;
      }
    }; //打开信息弹框


    const onOpenDetail = (row, tag) => {
      detailObj.value.visible = true;
      detailObj.value.from = Number(tag);
      detailObj.value.id = row.id;
      console.log('detailObj', detailObj.value);
      detailObj.value.dialogWidth = isIptvAccount ? '35%' : '65%';
    };

    const onCancel = () => {
      sortParams.value = {
        sortKey: undefined,
        isAsc: undefined
      };
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      getSnGroupList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, { ...searchParams.value,
        ...sortParams.value
      });
      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString(); //激活对应的tag标签

        handleTagClick({
          type: activeTag.value.toString()
        }); // 请求对应tag的列表数据
      });
    }; //监听激活tag的变化，配置searchConfig和table
    // todo:headerBUttonList可以做优化，全部写到以前，用controller:()=> void来控制那些按钮显示哪些隐藏


    watch(() => activeTag.value, (newVal, oldVal) => {
      tableConfig.data = [];
      sortParams.value = {
        sortKey: undefined,
        isAsc: undefined
      };
      tableRef.value && tableRef.value.commonTableRef.clearSort(); //清空排序条件

      switch (Number(newVal)) {
        case 0:
          console.log('激活了model列表');
          columnConfig.columnList = [{
            label: '',
            prop: '',
            type: 'selection'
          }, {
            label: 'Model',
            prop: 'modelName',
            align: 'left',
            width: 150,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '方案组',
            prop: 'solutionName',
            align: 'left',
            width: 150,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '品牌',
            prop: 'brandName',
            align: 'left',
            width: 120,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '定制IPTV',
            prop: 'name',
            align: 'left',
            width: 180,
            cellSlot: true,
            slotName: 'costomColumn'
          }, {
            label: '运营区域',
            prop: 'region',
            align: 'left',
            width: 150,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending'],
            formatter: value => setGlobalI18nText(value)
          }, {
            label: '3ID',
            prop: 'threeId',
            align: 'left',
            width: 130,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '备注',
            prop: 'comments',
            align: 'left',
            width: 150
          }, {
            label: '创建时间',
            prop: 'createTime',
            align: 'left',
            formatter: value => getCurrentTime(value)
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            fixed: 'right',
            width: 250,
            widgetType: 'buttons',
            buttonsList: [{
              label: '定制IPTV',
              func: data => {
                customIptvObj.value.visible = true, customIptvObj.value.from = 0;
                customIptvObj.value.id = data.id;
                customIptvObj.value.mode = data.isCustomization ? 'edit' : 'add'; // 根据接口返回的状态判断是编辑还是新增
              }
            }]
          }];
          tableConfig.headerButtonsList = [{
            label: t('批量'),
            type: 'primary',
            func: () => {
              verifyCustomInfo(selectedIdList.value, Number(activeTag.value) + 1, useCommon().userData.id, useCommon().userData.roles);
            }
          }, {
            label: '',
            key: 0,
            func: () => {},
            cellSlot: true
          }];
          getIptvModelList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 1:
          console.log('激活了组列表');
          columnConfig.columnList = [{
            label: '',
            prop: '',
            type: 'selection'
          }, {
            label: '名称',
            prop: 'name',
            align: 'left',
            width: 150,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: 'Model',
            prop: 'modelName',
            align: 'left',
            width: 150,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '品牌',
            prop: 'brandName',
            align: 'left',
            width: 120,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending'],
            controller: () => {
              if (!isIptvAccount) {
                return true;
              }
            }
          }, {
            label: '定制IPTV',
            prop: 'name',
            align: 'left',
            width: 150,
            cellSlot: true,
            slotName: 'costomColumn'
          }, {
            label: '运营区域',
            prop: 'region',
            align: 'left',
            width: 250,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending'],
            formatter: value => setGlobalI18nText(value)
          }, {
            label: '数量',
            prop: 'count',
            align: 'left',
            width: 130,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '备注',
            prop: 'remark',
            align: 'left'
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            fixed: 'right',
            width: 350,
            widgetType: 'buttons',
            buttonsList: [{
              label: '编辑',
              func: data => {
                editGroupObj.value.visible = true;
                editGroupObj.value.id = data.id;
              }
            }, {
              label: '定制IPTV',
              func: data => {
                customIptvObj.value.visible = true, customIptvObj.value.from = 1;
                customIptvObj.value.id = data.id;
                customIptvObj.value.mode = data.isCustomization ? 'edit' : 'add'; // 根据接口返回的状态判断是编辑还是新增
              }
            }, {
              label: '移除',
              func: data => {
                messageBox(`${t('确定移除SN')}`).then(() => {
                  deleteSnGroup(data.id);
                });
              }
            }]
          }];
          tableConfig.headerButtonsList = [{
            label: t('创建分组'),
            type: 'green',
            func: () => {
              createObj.value.visible = true;
            }
          }, {
            label: t('批量'),
            type: 'primary',
            func: () => {
              verifyCustomInfo(selectedIdList.value, Number(activeTag.value) + 1, useCommon().userData.id, useCommon().userData.roles);
            }
          }, {
            label: '',
            key: 0,
            func: () => {},
            cellSlot: true
          }];
          getSnGroupList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;

        case 2:
          console.log('激活了sn列表');
          columnConfig.columnList = [{
            label: '',
            prop: '',
            type: 'selection'
          }, {
            label: 'SN',
            prop: 'sn',
            align: 'left',
            width: 200,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: 'Model',
            prop: 'modelName',
            align: 'left',
            width: 300,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending']
          }, {
            label: '品牌',
            prop: 'brandName',
            align: 'left',
            width: 300,
            sortable: 'custom',
            'sort-orders': ['ascending', 'descending'],
            controller: () => {
              if (!isIptvAccount) {
                return true;
              }
            }
          }, {
            label: '定制IPTV',
            prop: 'name',
            align: 'left',
            cellSlot: true,
            slotName: 'costomColumn'
          }, // { label: '备注', prop: 'remark', align:'left', width: 300, sortable: 'custom', 'sort-orders': ['ascending', 'descending'] },
          {
            label: '操作',
            prop: '',
            align: 'left',
            fixed: 'right',
            width: 355,
            widgetType: 'buttons',
            buttonsList: [{
              label: '定制IPTV',
              func: data => {
                customIptvObj.value.visible = true, customIptvObj.value.from = 2;
                customIptvObj.value.id = data.id;
                customIptvObj.value.mode = data.isCustomization ? 'edit' : 'add'; // 根据接口返回的状态判断是编辑还是新增
              }
            }, {
              label: '移除',
              func: data => {
                messageBox(`${t('确定移除SN')}`).then(() => {
                  deleteIptvSnList(data.id);
                });
              }
            }]
          }];
          tableConfig.headerButtonsList = [// {
          //   label: t('导入'),
          //   type: 'primary',
          //   func: () => {
          //   }
          // },
          {
            label: t('添加SN'),
            type: 'green',
            func: () => {
              addSnObj.value.visible = true;
              addSnObj.value.from = activeTag.value;
            }
          }, {
            label: t('批量'),
            type: 'primary',
            func: () => {
              verifyCustomInfo(selectedIdList.value, Number(activeTag.value) + 1, useCommon().userData.id, useCommon().userData.roles);
            }
          }, {
            label: '',
            key: 0,
            func: () => {},
            cellSlot: true
          }];
          getIptvSnList(1, 10, { ...searchParams.value,
            ...sortParams.value
          });
          break;
      }
    }); // 获取品牌选项数据

    const getBrands = async () => {
      try {
        const brands = await useBrandsByUser(); // let searchItem = getItemByProp(searchConfig.formList, 'cid')
        // if (searchItem) searchItem.list = brands

        brandOptions.value = [{
          prefixName: t('全部'),
          cid: ''
        }, ...brands];
        const cid = cpspId;

        if (!cid) {
          sessionStorage.setItem('currentCid', brands[0].cid);
        }
      } catch (error) {}
    }; // 获取sn组列表


    const getSnGroupList = async (pageNo = 1, pageSize = 10, otherParams = {}) => {
      try {
        let params = { ...otherParams,
          userId: useCommon().userData.id,
          userType: isIptvAccount ? 1 : 0
        };
        const {
          code,
          data
        } = await getSnGroupListApi(pageNo, pageSize, params);

        if (code == 0) {
          tableConfig.data = data.records;
          tableConfig.paginationConfig = {
            limit: data.size,
            page: data.current,
            total: data.total
          };
        }
      } catch (error) {}
    }; // 获取model列表


    const getModelList = async params => {
      try {
        const {
          data,
          code
        } = await getModelsApi(params);

        if (code == 0 && data.length > 0) {
          let newModelList = data.map(item => {
            return { ...item,
              label: item.modelName,
              value: item.mid
            };
          });
          modelOptions.value = [{
            label: t('全部'),
            value: ''
          }, ...newModelList];
        } else {
          modelOptions.value = [{
            label: t('全部'),
            value: ''
          }];
        }
      } catch (error) {}
    }; // 获取方案组


    const getSolutionSelectData = async () => {
      try {
        const {
          code,
          data
        } = await getSolutionSelectDataAPi();

        if (code == 0) {
          pidOptions.value = [{
            label: t("全部"),
            value: ''
          }, ...data];
        }
      } catch (error) {}
    }; // 获取sn列表


    const getIptvSnList = async (pageNo = 1, pageSize = 10, otherParams = {}) => {
      try {
        loading.value = true;
        let params = { ...otherParams,
          userId: useCommon().userData.id,
          userType: isIptvAccount ? 1 : 0
        };
        const {
          code,
          data
        } = await getIptvSnListApi(pageNo, pageSize, params);

        if (code == 0) {
          tableConfig.data = data.records;
          tableConfig.paginationConfig = {
            limit: data.size,
            page: data.current,
            total: data.total
          };
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    }; // 删除sn列表


    const deleteIptvSnList = async id => {
      try {
        const {
          code,
          data
        } = await deleteIptvSnListApi(id);

        if (code == 0) {
          getIptvSnList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
        }
      } catch (error) {}
    }; // 移除sn组


    const deleteSnGroup = async id => {
      try {
        const {
          code,
          data
        } = await deleteSnGroupApi(id);

        if (code == 0) {
          getSnGroupList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
        }
      } catch (error) {}
    }; // 获取sn列表


    const getIptvModelList = async (pageNo = 1, pageSize = 10, otherParams = {}) => {
      try {
        loading.value = true;
        const {
          code,
          data
        } = await getIptvModelListApi(pageNo, pageSize, otherParams);

        if (code == 0) {
          tableConfig.data = data.records;
          tableConfig.paginationConfig = {
            limit: data.size,
            page: data.current,
            total: data.total
          };
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    }; //导入之前


    const handleBeforeUpload = val => {
      console.log('导入qian..', val);
      loading.value = true;
      dialogVisible.value = true;
    }; //导入失败


    const handleUploadFail = (response, file) => {
      console.log('导入失败', response);
      loading.value = false;
      dialogVisible.value = false;
      targetUpload.value.handleRemove(file); //清空浏览器保存的上次上传的文件

      getIptvSnList(1, 10, { ...searchParams.value,
        ...sortParams.value
      });
    }; //导入成功


    const handleUploadSuccess = (response, file) => {
      console.log('导入成功', file, file);

      if (response.code != 0 && response.code != -1) {
        ElMessage({
          type: 'error',
          message: t('Upload error, please upload again.')
        });
      } //下载错误文件


      if (response.code == '-1') {
        // 使用atob方法解码base64
        var raw = window.atob(response.data); // 创建一个存储解码后数据的数组

        var uInt8Array = new Uint8Array(raw.length); // blob只能接收二进制编码，需要讲base64转为二进制再塞进去

        for (var i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        } // 这里给了一个返回值，在别的方法掉用传入base64编码就可以得到转化后的blob


        const link = document.createElement('a');
        console.log('link'); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet xlsl类型

        const blob = new Blob([uInt8Array], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob); //设置下载的Excel表名

        link.setAttribute('download', `ERROR_IMPORT_${dayjs(new Date()).format('YYYY-MM-DD')}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        ElMessage({
          type: 'error',
          message: t('Upload error, please upload again.')
        });
      }

      loading.value = false;
      dialogVisible.value = false;
      targetUpload.value.handleRemove(file); //清空浏览器保存的上次上传的文件

      getIptvSnList(1, 10, { ...searchParams.value,
        ...sortParams.value
      });
    };

    const handleSelectionChange = row => {
      selectedIdList.value = [];
      selectedList.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedIdList.value.push(val.id);
          selectedList.value.push(val);
        });
      } //console.log('选择的频道',selectedChannel.value)

    }; // 打开定制iptv弹框


    const openCustomIptvDialog = (id, dataList) => {
      customIptvObj.value.visible = true;
      customIptvObj.value.from = activeTag.value;
      customIptvObj.value.data = dataList;
      customIptvObj.value.mode = 'batch';
      customIptvObj.value.id = id;
    }; // 校验是否存在定制信息/定制信息是否一致


    const verifyCustomInfo = async (ids, type, userId, roleNames) => {
      try {
        console.log('verifyCustomInfo', ids, type, userId, roleNames);

        if (!selectedIdList.value || selectedIdList.value.length === 0) {
          return ElMessage({
            type: 'error',
            message: t('请选择任意一个Model')
          });
        }

        loading.value = true;
        const {
          code,
          data
        } = await verifyCustomInfoApi(ids, type, userId, roleNames);

        if (code == 0) {
          // 整理传到弹框的数据，默认ui风格选择第一项, 缓存默认default, 运营区域默认全球
          let dataList = data.iptvCustomizationInfoDTOList ? data.iptvCustomizationInfoDTOList.map(item => {
            return { ...item,
              uiStyle: 0,
              cacheSize: item.cacheSize ? item.cacheSize : 0,
              region: item.region ? item.region : 'global'
            };
          }) : [];

          if (!data.exists) {
            //不存在定制信息
            openCustomIptvDialog(ids.join(','), dataList);
          } else {
            //存在定制信息
            if (data.same) {
              //定制信息相同
              openCustomIptvDialog(ids.join(','), dataList);
            } else {
              //定制信息不同
              let formType = type === 1 ? 'Model' : type === 2 ? 'SN Group' : 'SN';
              messageBox(`${t('选中批量操作{type}定制信息不同，继续操作批量将会清空已有设置，确定继续操作？', {
                type: formType
              })}`).then(() => {
                openCustomIptvDialog(ids.join(','), dataList);
              });
            }
          }
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };

    const sortParams = ref({
      sortKey: undefined,
      isAsc: undefined
    });

    const handleSortChange = sortType => {
      console.log('sortType', sortType);
      sortParams.value.sortKey = sortType.prop ? sortType.prop : undefined;

      if (sortType.order) {
        sortParams.value.isAsc = sortType.order === 'ascending' ? true : false;
      } else {
        sortParams.value.isAsc = undefined;
      }

      let params = { ...searchParams.value,
        ...sortParams.value
      };

      switch (Number(activeTag.value)) {
        case 0:
          getIptvModelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
          break;

        case 1:
          getSnGroupList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
          break;

        case 2:
          getIptvSnList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
          break;
      }
    }; // 设置global字符串为国际化


    const setGlobalI18nText = text => {
      //console.log('text',text)
      if (!text || text.length === 0) return '--';
      let globalTextArr = text.split(',').filter(item => item === 'global');

      if (globalTextArr.length > 0) {
        // 存在'global'字符串
        let noGlobalTextArr = text.split(',').filter(item => item !== 'global');
        text = [...noGlobalTextArr, t('global')].join(',');
      }

      return text;
    }; // 获取平台信息


    const getPlatformLists = async params => {
      try {
        let res = await getPlatformList(params);

        if (res.code == '0') {
          let resData = res.data.map(item => ({ ...item,
            prefixName: PrefixInteger(item.pid, 3) + '-' + item.name
          }));
          return resData;
        }

        return [];
      } catch (error) {}
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 50
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref_key: "tagRef",
        ref: tagRef
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [activeTag.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_upload, {
        ref_key: "targetUpload",
        ref: targetUpload,
        class: "upload_btn",
        action: _unref(actionUrl),
        method: "post",
        headers: uploadHeaders.value,
        limit: 1,
        "file-list": _ctx.fileList,
        "on-exceed": _ctx.handleExceed,
        "on-error": handleUploadFail,
        "on-success": handleUploadSuccess,
        "before-upload": handleBeforeUpload
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "green",
          style: {
            "width": "67px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('导入')), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["action", "headers", "file-list", "on-exceed"])])) : _createCommentVNode("", true), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.key == 0 ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
          key: 0,
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"])])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSortChange: handleSortChange,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          costomColumn: _withCtx(scope => [scope.row.isCustomization ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            link: "",
            onClick: $event => onOpenDetail(scope.row, activeTag.value)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('信息')), 1)]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString('--')))]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])], 512)], 512)])])), [[_directive_loading, loading.value], [_vShow, !editGroupObj.value.visible]]), _createVNode(EditGroup, {
        modelValue: editGroupObj.value.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editGroupObj.value.visible = $event),
        onCancel: onCancel,
        id: editGroupObj.value.id,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "id"]), _createVNode(CustomIptvDetail, {
        modelValue: detailObj.value.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => detailObj.value.visible = $event),
        data: detailObj.value.data,
        from: detailObj.value.from,
        dialogWidth: detailObj.value.dialogWidth,
        id: detailObj.value.id
      }, null, 8, ["modelValue", "data", "from", "dialogWidth", "id"]), _createVNode(CreateGroup, {
        modelValue: createObj.value.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => createObj.value.visible = $event),
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue"]), _createVNode(CustomIptv, {
        modelValue: customIptvObj.value.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => customIptvObj.value.visible = $event),
        mode: customIptvObj.value.mode,
        data: customIptvObj.value.data,
        from: customIptvObj.value.from,
        id: customIptvObj.value.id,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "mode", "data", "from", "id"]), _createVNode(AddSn, {
        modelValue: addSnObj.value.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => addSnObj.value.visible = $event),
        from: addSnObj.value.from,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "from"]), _createVNode(TipsDialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogVisible.value = $event)
      }, null, 8, ["modelValue"])], 64);
    };
  }

});